(() => {
  const storageKey = 'cocomelot:wishlist';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch {
      // Favorieten blijven optioneel als lokale opslag niet beschikbaar is.
    }
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);

  const update = () => {
    const items = read();
    const handles = new Set(items.map((item) => item.handle));

    document.querySelectorAll('[data-cc-wishlist-toggle]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    document.querySelectorAll('[data-cc-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });

    const container = document.querySelector('[data-cc-wishlist-items]');
    const empty = document.querySelector('[data-cc-wishlist-empty]');
    if (!container || !empty) return;

    empty.hidden = items.length > 0;
    container.innerHTML = items.map((item) => `
      <article class="cc-wishlist-item">
        <a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" alt="" width="96" height="120" loading="lazy"></a>
        <div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.title)}</strong></a><span>${escapeHtml(item.price)}</span><button type="button" data-cc-wishlist-remove="${escapeHtml(item.handle)}">Verwijderen</button></div>
      </article>
    `).join('');
  };

  const open = () => {
    const drawer = document.querySelector('[data-cc-wishlist]');
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('cc-drawer-open');
  };

  const close = () => {
    const drawer = document.querySelector('[data-cc-wishlist]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('cc-drawer-open');
    window.setTimeout(() => { drawer.hidden = true; }, 220);
  };

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-cc-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const items = read();
      const handle = toggle.dataset.productHandle;
      const index = items.findIndex((item) => item.handle === handle);
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift({
          handle,
          title: toggle.dataset.productTitle,
          url: toggle.dataset.productUrl,
          image: toggle.dataset.productImage,
          price: toggle.dataset.productPrice,
        });
      }
      write(items.slice(0, 50));
      update();
      return;
    }

    if (event.target.closest('[data-cc-wishlist-open]')) open();
    if (event.target.closest('[data-cc-wishlist-close]')) close();

    const remove = event.target.closest('[data-cc-wishlist-remove]');
    if (remove) {
      write(read().filter((item) => item.handle !== remove.dataset.ccWishlistRemove));
      update();
    }

    const share = event.target.closest('[data-cc-share]');
    if (share) {
      const data = { title: document.title, url: window.location.href };
      if (navigator.share) await navigator.share(data).catch(() => {});
      else await navigator.clipboard?.writeText(data.url).catch(() => {});
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  update();
})();
